<template>
<q-page class="main">
  <q-card class="page-card">
    <q-card-section v-if="$isDesktop" class="page-card__main-content">
      <div
          class="row items-center justify-between q-gutter-y-lg"
          :class="{ 'q-mb-lg': $isDesktop }"
      >
        <h1 class="heading-2">
          Kaartgroepen
        </h1>
      </div>
      <div class="row items-center justify-between">
        <div class="col-shrink">
          Kies een kaartgroep uit de lijst.
        </div>
      </div>
    </q-card-section>

    <q-card-section v-else class="page-card__main-content">
      <h1 class="heading-2 q-pl-sm">
        Kaartgroepen
      </h1>
      <MapGroupIndex :mapGroups="mapGroups" class="q-mt-md" />
    </q-card-section>
  </q-card>
  <StickyTopBar>
    <AccentButton
        v-if="$isDesktop"
        label="Importeer kaartbestand"
        @click="$goto('mapimport.form')"
        type="button"
    />
  </StickyTopBar>
  <StickyBottomBar v-if="!$isDesktop">
    <CommonFab
        label="Importeer kaartbestand"
        @click="$goto('mapimport.form')"
        type="button"
    />
  </StickyBottomBar>
</q-page>
</template>

<script>
import MapGroupIndex from '~HIOR/components/sidebars/MapGroupIndex'

export default {
  components: {
    MapGroupIndex,
  },
  props: {
    mapGroups: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

